import { useEffect, useState } from "react";
import getRegionsAPI from "../../Regions/api/getRegionsAPI";

import AlertComponent from "../../../components/AlertComponent";
import ErrorAlert from "../../../components/ErrorAlert";
import CreateUserForm from "../Components/CreateUserForm";

function CreateUser() {
  // data for user collection
  const [regions, setRegions] = useState([]);
  const [alert, setAlert] = useState("null");

  // fetch Region Data
  useEffect(() => {
    const fetchRegions = async () => {
      const regions = await getRegionsAPI();
      await setRegions(regions);
    };
    fetchRegions();
  }, []);

  return (
    <section className="body-font relative text-gray-600">
      <div className="container mx-auto flex px-5 py-4">
        <div className="flex w-full flex-col items-end rounded-lg bg-white p-8">
          {alert === "created" ? (
            <AlertComponent title="تسجيل مستخد جديد" content={"تم تسجيل المتسخدم الجديد بنجاح"} />
          ) : alert === "error" ? (
            <ErrorAlert
              title="حدث خطا ما"
              content="حدث خطا ما في عملية تسجيل مستخدم جديد, يرجى إدخال معلومات صحيحة والمحاولة مرة أخرى"
            />
          ) : (
            ""
          )}
          <h2 className="title-font text-lg font-semibold text-gray-900 mb-4">تسجيل مستخدم جديد</h2>
          <CreateUserForm regions={regions} setAlert={setAlert} />
        </div>
      </div>
    </section>
  );
}

export default CreateUser;
